import { Text } from "@react-pdf/renderer";
import { styles } from "./PdfStyles";

/** Large bold form heading */
export const PdfH1 = ({ children, style }) => (
  <Text style={[styles.formTitle, style]}>{children}</Text>
);

/** Section heading (H2 equivalent) */
export const PdfH2 = ({ children, style }) => (
  <Text style={[styles.sectionHeading, style]}>{children}</Text>
);

/** Sub-section heading */
export const PdfSubHeading = ({ children, style }) => (
  <Text style={[styles.subSectionHeading, style]}>{children}</Text>
);

/** Regular field label (normal weight) */
export const PdfFieldLabel = ({ children, style }) => (
  <Text style={[styles.fieldLabel, style]}>{children}</Text>
);

/** Field value (bold) */
export const PdfFieldValue = ({ children, style }) => (
  <Text style={[styles.fieldValue, style]}>{children}</Text>
);

/** Regular body text */
export const PdfBody = ({ children, style }) => (
  <Text style={[styles.bodyText, style]}>{children}</Text>
);

/** Inline bold span */
export const PdfBold = ({ children, style }) => (
  <Text style={[styles.inlineBold, style]}>{children}</Text>
);

/** Small regular inline text */
export const PdfSmall = ({ children, style }) => (
  <Text style={[styles.inlineRegular, style]}>{children}</Text>
);

/** Tiny note text (for PINs, footnotes) */
export const PdfNote = ({ children, style }) => (
  <Text style={[styles.pinNote, style]}>{children}</Text>
);

/** Muted / placeholder / fallback text */
export const PdfFallback = ({ children, style }) => (
  <Text style={[styles.fallbackText, style]}>{children}</Text>
);
